// ─────────────────────────────────────────────────────────────────────────────
// AXIS360 DISC Instrument — Index
// ─────────────────────────────────────────────────────────────────────────────
import { DISC_GROUPS, DISC_DIMS } from "./questionBank.js";
import { computeDISC, getProfile, ALL_PROFILES, scoreDISC } from "./scoring.js";
export { DISC_GROUPS, DISC_DIMS, computeDISC, getProfile, ALL_PROFILES, scoreDISC };

const DISC = {
  id:           "disc",
  name:         "DISC Profile",
  shortName:    "DISC",
  icon:         "🎭",
  color:        "#C62828",
  bg:           "#FFF8F0",
  description:  "28-item forced-choice DISC assessment based on Marston's DISC model. Produces a validated four-dimension personality profile with 16 style profiles.",
  desc:         "28 groups · 4 dimensions · 16 style profiles",
  publisher:    "AXIS360 Express",
  version:      "1.0",
  format:       "forced_choice",
  scaleType:    "disc_forced_choice",
  itemCount:    28,
  items:        28,
  timeLimit:    12,
  time:         "12 min",
  timeEstimate: "~12 min",
  isScreener:   false,
  isPersonality:true,
  pricingTier:  "core",
  creditCost:   15,
  questions:    DISC_GROUPS,
  dimensions:   DISC_DIMS,
  score(answers) { return computeDISC(answers); },
};
export default DISC;
